import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Building2, Plus } from "lucide-react";
import { toast } from "sonner";
import { apiErrorMessage } from "@/lib/api";

export default function AdminCompanies() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ name: "", slug: "", primary_color: "#1a3a5c", secondary_color: "#c8232c", plan: "starter" });

  const refresh = async () => { const { data } = await api.get("/companies"); setItems(data); };
  useEffect(() => { refresh(); }, []);

  const save = async () => {
    try {
      await api.post("/companies", form);
      toast.success("Empresa criada");
      setForm({ name: "", slug: "", primary_color: "#1a3a5c", secondary_color: "#c8232c", plan: "starter" });
      refresh();
    } catch (e) { toast.error(apiErrorMessage(e)); }
  };

  return (
    <div className="space-y-8" data-testid="admin-companies-page">
      <header>
        <div className="eyebrow">Master · Multi-tenant</div>
        <h1 className="font-display text-3xl md:text-4xl font-extrabold tracking-tight mt-1">Empresas clientes</h1>
        <p className="text-slate-600 mt-2 text-sm">Gerencie todas as empresas da plataforma. Cada empresa tem seu próprio espaço com white label.</p>
      </header>
      <Card><CardContent className="p-6">
        <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-3 items-end">
          <div><Label>Nome</Label><Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="company-name" /></div>
          <div><Label>Slug</Label><Input value={form.slug} onChange={(e) => setForm({ ...form, slug: e.target.value.toLowerCase() })} data-testid="company-slug" /></div>
          <div><Label>Cor primária</Label><Input type="color" value={form.primary_color} onChange={(e) => setForm({ ...form, primary_color: e.target.value })} /></div>
          <div><Label>Cor secundária</Label><Input type="color" value={form.secondary_color} onChange={(e) => setForm({ ...form, secondary_color: e.target.value })} /></div>
          <Button onClick={save} className="btn-navy" data-testid="company-add-btn"><Plus className="w-4 h-4 mr-2" />Cadastrar</Button>
        </div>
      </CardContent></Card>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {items.length === 0 && <Card className="col-span-full"><CardContent className="p-10 text-center text-slate-600"><Building2 className="w-10 h-10 mx-auto text-slate-400 mb-3" />Nenhuma empresa cadastrada.</CardContent></Card>}
        {items.map((c) => (
          <Card key={c.id}><CardContent className="p-5">
            <div className="flex items-center justify-between">
              <div>
                <div className="font-display font-bold text-lg">{c.name}</div>
                <div className="text-xs text-slate-500">/{c.slug} · plano {c.plan}</div>
              </div>
              <div className="flex gap-1">
                <span className="w-5 h-5 rounded" style={{ background: c.primary_color }} />
                <span className="w-5 h-5 rounded" style={{ background: c.secondary_color }} />
              </div>
            </div>
          </CardContent></Card>
        ))}
      </div>
    </div>
  );
}
